;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();type CommentVisualizationKeyParams = {
	viewVisualizationId?: string;
	workspaceId: string;
};

export const commentQueryKeys = {
	all: ["comments"] as const,
	list: ({ viewVisualizationId, workspaceId }: CommentVisualizationKeyParams) =>
		[
			...commentQueryKeys.workspacePrefix(workspaceId),
			viewVisualizationId,
		] as const,
	mentions: ({
		viewVisualizationId,
		workspaceId,
	}: CommentVisualizationKeyParams) =>
		[
			...commentQueryKeys.mentionsPrefix(workspaceId),
			viewVisualizationId,
		] as const,
	mentionsAll: ["mentions"] as const,
	mentionsPrefix: (workspaceId: string) =>
		[...commentQueryKeys.mentionsAll, workspaceId] as const,
	workspacePrefix: (workspaceId: string) =>
		[...commentQueryKeys.all, workspaceId] as const,
};

export const commentMutationKeys = {
	create: (viewVisualizationId: string) =>
		[...commentQueryKeys.all, viewVisualizationId, "create"] as const,
};
